module.exports = __webpack_public_path__ + "static/media/engine_capacity.78a47fcb.svg";